import { api } from '@setplex/tria-api'
import { attach, restore } from 'effector'

// *
// * STORES
// *

export const loadLiveEventFx = attach({
  effect: api.liveEvents.getLiveEventByIdFx,
})

export const $currentLiveEvent = restore(loadLiveEventFx.doneData, null)
